var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "filters-container" }, [
    _c(
      "button",
      { staticClass: "drawer-button", on: { click: _vm.openDrawer } },
      [
        _c("div", { staticClass: "filter-count" }, [
          _vm._v(_vm._s(_vm.filterCount)),
        ]),
        _c("span", [_vm._v("Filters")]),
        _c(
          "span",
          {
            staticClass: "filter-clear-icon",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.clearFilters.apply(null, arguments)
              },
            },
          },
          [_vm._v("×")]
        ),
      ]
    ),
    _vm.isDrawerOpen
      ? _c("div", {
          staticClass: "drawer-backdrop",
          on: { click: _vm.closeDrawer },
        })
      : _vm._e(),
    _c(
      "div",
      { staticClass: "drawer", class: { "drawer-open": _vm.isDrawerOpen } },
      [
        _c("div", { staticClass: "drawer-header" }, [
          _c("h3", [_vm._v("Filters")]),
          _c(
            "button",
            { staticClass: "close-button", on: { click: _vm.closeDrawer } },
            [_vm._v("×")]
          ),
        ]),
        _c(
          "div",
          { staticClass: "search-area", on: { click: _vm.focusSearchField } },
          [
            _c("div", { staticClass: "search-container" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.searchQuery,
                    expression: "searchQuery",
                  },
                ],
                ref: "search",
                staticClass: "search-field",
                attrs: { placeholder: "Search by section name" },
                domProps: { value: _vm.searchQuery },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.searchQuery = $event.target.value
                  },
                },
              }),
              !_vm.searchQuery
                ? _c("img", {
                    staticClass: "search-icon",
                    attrs: {
                      src: "assets/images/search.svg",
                      width: "16",
                      height: "16",
                    },
                  })
                : _vm._e(),
              _vm.searchQuery
                ? _c("span", {
                    staticClass: "clear-icon",
                    on: { click: _vm.clearSearch },
                  })
                : _vm._e(),
            ]),
          ]
        ),
        _c(
          "div",
          { staticClass: "drawer-content" },
          [
            _vm._l(_vm.filteredFilters, function (filter) {
              return filter.show
                ? _c("div", { key: filter.id, staticClass: "filter-group" }, [
                    _c(
                      "div",
                      {
                        staticClass: "filter-group-header",
                        on: {
                          click: function ($event) {
                            return _vm.toggleFilterGroup(filter.id)
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "filter-group-header-content" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "accordion-icon",
                                class: { open: filter.open },
                              },
                              [_c("i", { staticClass: "fa fa-angle-right" })]
                            ),
                            _c("h4", [
                              _vm._v(
                                _vm._s(filter.name) +
                                  " " +
                                  _vm._s(
                                    _vm.showFilterCount(filter)
                                      ? "(" + _vm.showFilterCount(filter) + ")"
                                      : ""
                                  )
                              ),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "filter-group-header-actions" },
                          [
                            _c("i", {
                              staticClass:
                                "fa fa-times filter-group-header-clear-icon",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.clearFilterGroup(
                                    filter.id,
                                    filter.type
                                  )
                                },
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: filter.open,
                            expression: "filter.open",
                          },
                        ],
                        staticClass: "filter-group-content",
                      },
                      [
                        filter.type === "button"
                          ? _c("button-filter", {
                              attrs: {
                                entries: filter.entries,
                                "query-key": filter.id,
                                "only-entries": filter.onlyEntries,
                              },
                              on: {
                                "item-click": _vm.handleUpdateButtonFilters,
                              },
                            })
                          : _vm._e(),
                        filter.type === "checkbox"
                          ? _c("checkbox-filter", {
                              ref: "checkbox-filter-" + filter.id,
                              refInFor: true,
                              attrs: {
                                data: filter.entries,
                                "filter-id": filter.id,
                                tenant: _vm.tenant,
                                "has-search": filter.search,
                                "selected-items": filter.selectedItems,
                              },
                              on: {
                                "selection-change":
                                  _vm.handleUpdateCheckboxFilters,
                              },
                            })
                          : _vm._e(),
                        filter.type === "radio"
                          ? _c("radio-btn-filter", {
                              ref: "radio-filter-" + filter.id,
                              refInFor: true,
                              attrs: {
                                data: filter.entries,
                                "filter-id": filter.id,
                                tenant: _vm.tenant,
                                "has-search": filter.search,
                                "selected-items": filter.selectedItems,
                              },
                              on: {
                                "selection-change":
                                  _vm.handleUpdateRadioBtnFilters,
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ])
                : _vm._e()
            }),
            _vm.noResultsFound
              ? _c("div", { staticClass: "filter-group" }, [
                  _vm._v("No results found"),
                ])
              : _vm._e(),
            _c("div", { staticClass: "drawer-footer" }, [
              _c(
                "button",
                {
                  staticClass: "pxl-button apply-button",
                  attrs: { disabled: _vm.disableActionButton },
                  on: { click: _vm.applyFilters },
                },
                [_vm._v("Apply")]
              ),
              _c(
                "button",
                {
                  staticClass: "clear-button",
                  attrs: { disabled: _vm.disableActionButton },
                  on: { click: _vm.clearFilters },
                },
                [_vm._v("Clear All")]
              ),
            ]),
          ],
          2
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }